import { CookieConsentContext } from './CookieConsentProvider';
import { useContext } from 'react';

export const useCookieConsents = () => {
  const consents = useContext(CookieConsentContext);
  return consents;
};
